export default "__VITE_ASSET__DzBBkIXp__"